export default __webpack_public_path__ + "static/SONY_WDRMODE_0_ALL_AUTO_NIGHT-c3f7ed640879deecbcbd8f083e3049fd.webp";